<div class="multiselect">
  <div class="selectBox" (click)="showCheckboxes($event)">
    <select [ngClass]="getClassName()" title="Search by {{header.label}}">
      <option>{{header.label}}</option>
    </select>
    <div class="overSelect"></div>
  </div>

  @if (header.expanded) {
    <div class="checkboxes-selected">
      @for (l of selectable; track l; let i = $index) {
        <div>
          <label for="{{i}}">
            <input type="checkbox" checked (change)="onRemoveFilter($event, l, i)" />{{selectable[i].show}}
          </label>
        </div>
      }
    </div>
  }

  @if (header.expanded) {
    <div class="checkboxes-empty">
      @if (header.searchtype != 'checkbox') {
        <input class="textbox-search" type="{{header.searchtype}}" (keyup)="onChange($event)" (change)="onChange($event)" />
      }
      @for (l of toSelectable; track l; let i = $index) {
        <div>
          <label for="{{i}}">
            <input type="checkbox" (change)="onSelectToFilter($event, l, i)" />{{toSelectable[i].show}}
          </label>
        </div>
      }
    </div>
  }

</div>